<template>
    <div id="projects">
        <div class="content-wrapper">
            <modals-container @confirm="confirmDeleteProject"></modals-container>
            <div class="page-heading">
            </div>
            <div class="page-content fade-in-up">
                <div class="row">
                    <div class="col-md-12">
                        <div class="ibox">
                            <div class="ibox-body projects-wrapper">               
                                    <div class="col-md-12 mb-5">
                                         <div class="row">
                                                    <span style="padding-top: 7px;"><b>{{$t('message.selectCategoryForSorting')}}:</b></span>
                                                    <select v-model="value">
                                                        <option value="start_date">{{$t('message.startDate')}}</option>
                                                        <option value="end_date">{{$t('message.endDate')}}</option>
                                                        <option value="name">{{$t('message.projectName')}}</option>
                                                    </select>
                                                    <button class="btn view" @click="sortProjects()"><i class="fa" v-bind:class="[isArrowDown ? 'fa-sort-asc' : 'fa-sort-desc']"></i></button>
                                                    <button class="btn view" @click="showRegularView = !showRegularView"><i class="fa" v-bind:class="[showRegularView ? 'fa-list-ul' : 'fa-th-large']" ></i></button>        
                                        </div>
                                        <div v-if="showRegularView" class="row">
                                            <div v-for="(project, index) in projects" :key="index"
                                                 class="col-lg-3 col-md-4 box">

                                                <div class="project-box-wrapper">
                                                    <div class="image-wrapper">
                                                        <router-link 
                                                                :to="{name: 'EditProject', params: {id: project.id}}">
                                                            <img style="object-fit: cover; height: 100%; width: 100%;"
                                                                 :src="returnImage(project.profile_image)" alt="image">
                                                        </router-link>

                                                    </div>
                                                    <div class="delete-button-wrapper">
                                                        <span @click="deleteProject(project)"><i
                                                                style="font-size: 1.1em; cursor: pointer;"
                                                                class="fa fa-trash"></i></span>
                                                    </div>
                                                    <label class="mt-2"><b>{{$t('message.projectName')}}: </b>{{project.name}}</label><br>

                                                    <label><b>{{$t('message.startDate')}}:</b> <span v-if="project.start_date">{{project.start_date}}</span><span v-if="!project.start_date">{{$t('message.noStartDate')}}</span></label><br>

                                                    <label><b>{{$t('message.endDate')}}:</b> <span v-if="project.end_date" >{{project.end_date}}</span><span v-if="!project.end_date">{{$t('message.noEndDate')}}</span></label><br>

                                                    <label><b>{{$t('message.status')}}:</b> <span v-if="project.status">{{$t('message.active')}} <button style="height: 12px; width: 12px" class="btn btn-sm btn-success btn-circle activity-button"></button></span><span v-if="!project.status">{{$t('message.notActive')}} <button style="height: 12px; width: 12px" class="btn btn-sm btn-danger btn-circle activity-button"></button></span></label><br>
                                                </div>
                                            </div>
                                              
                                            <div style="width: 100%" class="text-center" v-if="projects.length === 0">
                                                <h1 style="color: #bfbfbf; margin-top: 3%;">
                                                    {{$t('message.noProjects')}}</h1>
                                            </div>
                                        </div>
                                        <div v-if="!showRegularView" class="row">
                                             <div class="col-md-12">
                                                        <table class="table table-striped">
                                                            <thead>
                                                            <tr>
                                                                <th scope="col"></th>
                                                                <th scope="col">{{$t('message.projectName')}}</th>
                                                                <th scope="col">{{$t('message.startDate')}}</th>
                                                                <th scope="col">{{$t('message.endDate')}}</th>
                                                                <th scope="col">{{$t('message.status')}}</th>
                                                            </tr>
                                                            </thead>
                                                            <tbody v-if="projects.length !== 0">
                                                            <tr v-for="(project, index) in projects" :key="index">
                                                                <th scope="row">{{index + 1}}</th>
                                                                <router-link
                                                                  :to="{name: 'EditProject', params: {id: project.id}}">
                                                                  <td scope="col">{{project.name}}</td>
                                                                </router-link>
                                                                <td scope="col">{{project.start_date}}</td>
                                                                <td scope="col">{{project.end_date}}</td>
                                                                <td scope="col"><span v-if="project.status">{{$t('message.active')}} <button style="height: 12px; width: 12px" class="btn btn-sm btn-success btn-circle activity-button"></button></span><span v-if="!project.status">{{$t('message.notActive')}} <button style="height: 12px; width: 12px" class="btn btn-sm btn-danger btn-circle activity-button"></button></span></td>
                                                                
                                                            </tr>
                                                            </tbody>
                                                        </table>
                                                    </div>
                                    
                                            <div style="width: 100%" class="text-center" v-if="projects.length === 0">
                                                <h1 style="color: #bfbfbf; margin-top: 3%;">
                                                    {{$t('message.noProjects')}}</h1>
                                            </div>
                                        </div>
                                    </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div  class="row">
                   <div class="col-md-12">
                                <div class="row">
                                    <div class="col-md-12 mb-5">                  
                                <router-link :to="{name: 'AddProject'}">
                                    <button class="btn btn-circle btn-success add-project-btn
                                    "><i class="fa fa-plus"></i></button>
                                </router-link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            
        </div>
    </div>
</template>

<script>
  import DialogModal from '../../../modals/DialogModal'

  export default {
    name: 'Projects',
    data () {
      return {
        altImage: '/assets/noImg.jpg',
        projects: [],
        showRegularView: true,
        isArrowDown: true,
        value: 'start_date',
        order_by: '?order_by='
      }
    },
    mounted () {
      this.getList(this.apiPrefix, this.projectApiUrl)
        .then(resp => {

          const mappedData = resp.data.map(row => ({
              id: row.id,
              name: row.name,
              start_date: row.start_date,
              end_date: row.end_date,
              status: row.status,
              // make the correct string of incorrect input
              profile_image: row.profile_image
            }))
          this.projects = mappedData

        })
        .catch(err => {
          console.log(err)
        })
    },
    methods: { 
      // in case profile_image does not exist, return alternative image
      returnImage (image) {
        if (image)
          return image.image
        return this.altImage
      },  
      deleteProject (project) {
        this.$modal.show(DialogModal, {
            text: `${this.$t('message.confirmDelete')} ${project.name}? ${this.$t('message.thisOperationCanNotBeUndone')}`,
            param: project.id,
            textColor: '#e74c3c',
            event: 'confirm'
          },
          {
            width: this.modalWidth(),
            height: 'auto'
          })
      },
      confirmDeleteProject (projectId) {
        this.delete(this.apiPrefix, this.projectApiUrl, projectId)
          .then(() => {
            this.projects = this.projects.filter(proj => {
              return proj.id !== projectId
            })
          })
          .catch(err => {
            console.log(err)
          })
      },
      sortProjects(){
          
          let order_by=''

          this.isArrowDown = !this.isArrowDown
          if(!this.isArrowDown){
              order_by+='-'
          }

          order_by+=this.value

          this.projects.sort(this.dynamicSort(order_by))
      },
      dynamicSort(property) {
          let sortOrder = 1;
          if(property[0] === "-") {
              sortOrder = -1;
              property = property.substr(1);
          }
          return function (a,b) {
              let result = (a[property] < b[property]) ? -1 : (a[property] > b[property]) ? 1 : 0;
              return result * sortOrder;
          }
      }

    }
  }
</script>

<style>
    .projects-wrapper {
        min-height: 200px;
    }

    .add-project-btn {
        position: absolute;
        right: 2%;
        bottom: 5px;
        box-shadow: 0 5px 5px -3px rgba(0, 0, 0, .2), 0 8px 10px 1px rgba(0, 0, 0, .14), 0 3px 14px 2px rgba(0, 0, 0, .12);
    }

    .project-box-wrapper {
        color: grey;
        margin: 2%;
        border: 1px solid rgba(220, 220, 220, 0.6);
        border-radius: 4px;
        box-shadow: 0 5px 5px -3px rgba(0, 0, 0, .2), 0 8px 10px 1px rgba(0, 0, 0, .14), 0 3px 14px 2px rgba(0, 0, 0, .12);
        min-height: 188px;
        padding: 9px;
    }

    .project-box-wrapper:hover {
        background-color: rgba(220, 220, 220, 0.3);
    }

    .delete-button-wrapper {
        position: absolute;
        top: 5%;
        right: 40px;
    }

    .image-wrapper {
        height: 200px;
        overflow: hidden;
        position: relative;
        width: 100%;
    }

    .view {
      margin: 1px;
      display: inline-block;
      height: 35px;
      width: 35px;
      outline: none;
      color: #74646E;
      border: 1px solid #C8BFC4;
      border-radius: 4px;
      box-shadow: inset 1px 1px 2px #DDD8DC;
      background: #FFF;
    }

    select {
        text-align-last:center;    
        border-radius: 4px;
        margin: 2px;
        background-color: #FFF;
        width: 165px;
        font-size: 16px;
        border: 1px solid #CCC;
        box-shadow: inset 1px 1px 2px #DDD8DC;
        height: 34px;
    }

    button:hover{
        cursor:pointer;
    }
</style>